<template>
  <div class="tw:w-full tw:sm:mx-4 tw:lg:mx-0 tw:relative tw:mb-6">
    <div v-if="isLoading" class="tw:rounded-xl tw:animate-pulse tw:bg-gray-300 tw:h-[658px]"></div>
    <div v-else-if="isError">
      <p class="tw:text-center tw:text-xl">{{ $t('onboarding.appLaunchError.header') }}</p>
    </div>
    <BiddingModeOverview v-else />
    <FullScreenLoader v-show="!isLoading && isFetching" />
  </div>
</template>
<script setup lang="ts">
import BiddingModeOverview from '@/components/rateConnect/biddingGoals/BiddingModeOverview.vue'
import FullScreenLoader from '@/components/base/loaders/FullScreenLoader.vue'
import { useCampaign } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'

const { isLoading, isFetching, isError } = useCampaign(selectedAccommodationId)
</script>
